import { Theme } from "common";

export const outreachDetailsStyles = {
  outrachTableOutline: {
    "&& .MuiTableCell-root": {
      border: `1px solid ${Theme.palette.grey[400]}`,
    },
  },
  outreachTableCellCustomPadding: {
    "&& .MuiTableCell-root": {
      padding: "0px",
    },
    "&& .MuiGrid-item": {
      padding: "8px",
    },
    "&& .MuiInputBase-input": {
      textAlign: "right",
      padding: "0px",
    },
  },
  outreachDetailsTypo: {
    marginLeft: "25px",
  },
  OutreachDetailsTitle: {
    "&&": {
      borderBottom: `1px solid ${Theme.palette.common.black}`,

      "&& h2": {
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",

        svg: {
          marginRight: "6px",
        },
      },
    },
  },
};
